export interface IScheduleEntityTypeModel {
    scheduleEntityTypeId: number;
    scheduleEntityTypeName: string;
    sortOrder?: number;
    legacyEntityTypeId: number;
    businessLineId: number;
    isGloballyScheduled: boolean;
}
/**
 * This model shows the relation between a ScheduleEntityTypeId and a ScheduleBlockTypeId
 * it's used to determine which ScheduleBlockTypes are allowed for a ScheduleEntityType
 */
export class ScheduleEntityTypeModel implements IScheduleEntityTypeModel {
    scheduleEntityTypeId: number;
    scheduleEntityTypeName: string;
    sortOrder?: number;
    legacyEntityTypeId: number;
    businessLineId: number;
    isGloballyScheduled: boolean;

    constructor(model: IScheduleEntityTypeModel) {
        this.scheduleEntityTypeId = model.scheduleEntityTypeId;
        this.scheduleEntityTypeName = model.scheduleEntityTypeName;
        this.sortOrder = model.sortOrder;
        this.legacyEntityTypeId = model.legacyEntityTypeId;
        this.businessLineId = model.businessLineId;
        this.isGloballyScheduled = model.isGloballyScheduled;
    }
}
